class AssistantSkills {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = basePath;

  }

  bootstrap(query, urlParameters) {

    const path = `${this.basePath}/assistant-skills/bootstrap`;

    return this.apiClient.post(path, {}, {}, { query, urlParameters });

  }

  setupAssistantSkill(data) {

    const path = `${this.basePath}/assistant-skills/setup`;

    return this.apiClient.post(path, {}, {}, data);

  }

  updateSkill(skillId, data) {

    const path = `${this.basePath}/skills/:skillId`;

    return this.apiClient.put(path, { skillId }, {}, data);

  }

  setSkillVisibility(skillId, data) {

    const path = `${this.basePath}/skills/:skillId/visibility`;

    return this.apiClient.put(path, { skillId }, {}, data);

  }

  deleteAssistantSkill(skillId) {

    const path = `${this.basePath}/skills/:skillId`;

    return this.apiClient.delete(path, { skillId });

  }

  addSkillResource(skillId, data) {

    const path = `${this.basePath}/skills/:skillId/resources`;

    return this.apiClient.post(path, { skillId }, {}, data);

  }

  removeSkillResource(skillId, skillResourceId) {

    const path = `${this.basePath}/skills/:skillId/resources/:skillResourceId`;

    return this.apiClient.delete(path, { skillId, skillResourceId });

  }

  getPopulatedAssistantSkill(assistantSkillId) {

    const path = `${this.basePath}/assistant-skills/:assistantSkillId`;

    return this.apiClient.get(path, { assistantSkillId }, {});

  }

  setAssistantSkillEnabled(assistantSkillId, data) {

    const path = `${this.basePath}/assistant-skills/:assistantSkillId/enabled`;

    return this.apiClient.put(path, { assistantSkillId }, {}, data);

  }

  setAssistantSkillVisibility(assistantSkillId, data) {

    const path = `${this.basePath}/assistant-skills/:assistantSkillId/visibility`;

    return this.apiClient.put(path, { assistantSkillId }, {}, data);

  }

  getSkills(assistantId) {

    const path = `${this.basePath}/assistants/:assistantId/skills`;

    return this.apiClient.get(path, { assistantId }, {});

  }

  getSkillByIdAndAssistantId(assistantId, skillId) {

    const path = `${this.basePath}/assistants/:assistantId/skills/:skillId`;

    return this.apiClient.get(path, { assistantId, skillId }, {});

  }

  getSkillResourcesBySkillId(assistantId, skillId) {

    const path = `${this.basePath}/assistants/:assistantId/skills/:skillId/resources`;

    return this.apiClient.get(path, { assistantId, skillId }, {});

  }

}

export default AssistantSkills;